import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";

export const exportFile = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.EXPORT_FILE + '/initialize', payload, token);
        return response;
    } catch (err) {
        console.log("Error in exportFile : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}

export const getExportFile = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.EXPORT_FILE + '/downloadFile', payload, token);
        return response;
    } catch (err) {
        console.log("Error in exportFile : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}
